// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__JcTwK","formControl":"addForm_formControl__Dol+5","list":"addForm_list__ZXMwD","btnWrpper":"addForm_btnWrpper__w62l4"};